module.exports = __webpack_public_path__ + "static/media/dartsafearea-png.fd142e0f.png";